
const m = window.require("discourse/helpers/format-username");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
